module.exports = __webpack_public_path__ + "img/icon-1-bg.ff14f56a.png";